import React, { useState } from "react";
import { PiXFill } from "react-icons/pi";
import { postApi } from "../../../services/api/globalApi";
import {
  errorMessage,
  successMessage,
} from "../../../utils/toastify-message/ToastifyMessage";
import { useNavigate } from "react-router";

const { forwardRef, useRef, useImperativeHandle } = React;

const LoanModal = forwardRef(({ userData }, ref) => {
  const [showModal, setShowModal] = useState(false);

  useImperativeHandle(ref, () => ({
    showModal() {
      setShowModal(!showModal);
    },
    afterSubmit() {},
  }));

  const navigate = useNavigate();

  const formHandler = async () => {
    const path = "/admin/loans";
    const body = {
      nationalId: userData?.nationalId || "",
      referrerUserNationalId: userData?.referrerUserNationalId || "",
      job: userData?.job || "",
      jobDescription: userData?.jobDescription || "",
      bankAccountId: userData?.bankAccountId || "",
      mobile: userData?.mobile || "",
    };
    try {
      const response = await postApi({ path, body });
      console.log(response);
      successMessage("وام کاربر با موفقیت ایجاد شد.");
      navigate(`/loan/${response?.data?.data?._id}`);
      setShowModal(false);
    } catch (error) {
      console.log(error);
      errorMessage(error?.response?.data?.errors[0]?.message);
    }
  };

  return (
    <>
      <div
        className={`fixed top-0 right-0 w-full h-full bg-black/40 transition-all z-[1500]  ${
          !showModal && "hidden"
        }`}
      ></div>
      <div
        className={`w-[300px] sm:w-[800px] py-4 max-h-[360px] overflow-y-scroll bg-white dark:bg-neutral-500 mt-4 shadow-md z-[1501] rounded-3xl p-4 transition-all fixed top-0 right-[50%] mr-[-170px] sm:mr-[-400px] opacity-0 invisible ${
          showModal && "!mt-20 !opacity-100 !visible"
        }`}
      >
        <div className="w-full px-6 flex items-center justify-between py-4 border-b-2">
          <h4 className="text-gray-800 dark:text-white">{` کاربر ${
            userData?.name || "-"
          }`}</h4>
          <PiXFill
            onClick={() => setShowModal(false)}
            size={30}
            className="text-red-400 transition-all hover:text-red-600 cursor-pointer"
          />
        </div>
        <div className="flex items-center justify-center text-gray-800 dark:text-white py-6">
          <p>
            آیا میخواهید برای کاربر {userData?.name || "-"} وام ایجاد کنید ؟
          </p>
        </div>
        <div className="flex gap-2 justify-end w-full">
          <button
            type="button"
            onClick={() => setShowModal(false)}
            className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
          >
            بازگشت
          </button>
          <button
            onClick={formHandler}
            type="button"
            className="text-white bg-green-700 hover:bg-green-800 focus:ring-4 focus:ring-green-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-green-500 dark:hover:bg-green-700 focus:outline-none dark:focus:ring-green-800"
          >
            ایجاد وام
          </button>
        </div>
      </div>
    </>
  );
});
export default LoanModal;
